import { useCallback, useEffect } from 'react';
import type { MouseEvent } from 'react';
import type { SuperBottomSheetProps } from './SuperBottomSheet.types';

export interface SuperBottomSheetViewModel {
  handleBackdropClick: (e: MouseEvent<HTMLDivElement>) => void;
}

export function useSuperBottomSheet(props: SuperBottomSheetProps): SuperBottomSheetViewModel {
  const { open, onClose } = props;

  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  const handleBackdropClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose],
  );

  return { handleBackdropClick };
}
